<template>
    <div class="blackBg  animated slideInLeft">
        <div class="cardTit">
            <span class="season">{{$store.state.seasonName}}</span>
            <span class="teamName">{{$store.state.teamName.split('_')[0]}}</span>
        </div>
        <div class="cardBg">
            <p class="contTit">YoYo</p>
            <div class="teamReport">
                <div class="barTitCol">
                    <span class="titLab titGreen"><Icon type="md-arrow-up" /></span> <span class="titCol titColGreen"></span>
                    <span class="titLab titRed"><Icon type="md-arrow-forward" /></span> <span class="titCol titColRed"></span>
                    <span class="titLab titYellow"><Icon type="md-arrow-down" /></span> <span class="titCol  titColYellow"></span>
                    <span class="titLab titBlue">N/A</span> <span class="titCol titColBlue"></span>
                </div>
                <div class="barBox">
                    <div v-if="labelId!=''" id="yoyoBar" style="height: 95%;width: 100%"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "bodyEndurance",
        data(){
            return{
                seasonId:this.$store.state.seasonId,//赛季id
                labelId:"",//标签id
                yoyoReportItem: [],
                yoyoReportName:[],//周数组
                yoyoReportData:[],//ac总数据
                scrollDomWidth:0,//滚动宽度
                scrollTime:0,//滚动时间
                time:null,//定时器
            }
        },
        computed: {
            teamIdFn(){
                return this.$store.state.teamId;
            }
        },
        watch:{
            teamIdFn(val,old){
                if(val!=old){
                    this.info();
                }
            },
        },
        mounted() {
            this.info();
        },
        methods:{
            info(){
                let data={
                    teamId:this.$store.state.teamId
                }
                this.$server.physicalTestLabel(data)
                    .then(res=>{
                        this.labelId=res.data.length?res.data[res.data.length-1].id:"";//标签id
                        if(res.data.length) {
                            this.getyoyoReportFn();
                        }
                    })
            },
            getyoyoReportFn(){
                let data = {
                    physicalTestId:this.labelId
                }
                this.$server.getYoyoReport(data).then((res) => {
                    if(res.code == 200){
                        this.yoyoReportName = [];
                        this.yoyoReportData = res.data;
                        for (let i in this.yoyoReportData){
                            this.yoyoReportName.push( this.yoyoReportData[i].playerName);
                            this.yoyoReportItem.push( this.yoyoReportData[i].distance);
                        }
                        this.yoyoReportBar(this.yoyoReportItem);
                    }
                })
            },
            yoyoReportBar(data){
                let dom = document.getElementById('yoyoBar');
                let myChart = this.$echarts.init(dom);
                let lookDom=document.querySelector('.teamReport')
                //柱状图显示宽度
                if(parseInt(lookDom.offsetWidth) > (200 * this.yoyoReportName.length)){
                    dom.style.width = (parseInt(lookDom.offsetWidth))+'px';
                }else{
                    dom.style.width = (200 * this.yoyoReportName.length) + "px";
                }
                myChart.resize();
                let option = null;

                option = {
                    tooltip: {
                        trigger: 'axis'
                    },
                    grid: {
                        top: '25%',
                        left: '0',
                        right: '5%',
                        bottom: '0',
                        containLabel: true
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: this.yoyoReportName,
                            axisLabel: {
                                color:'#fff',
                                fontSize:16,
                                margin:20,
                            },
                            axisLine: {       // 坐标轴 轴线
                                show: true,  // 是否显示
                                // ------   线 ---------
                                lineStyle: {
                                    color: 'rgba(255, 255, 255, .5)',
                                    width: 1,
                                    type: 'solid',
                                    opacity: '0.3',
                                }
                            },
                            splitLine :{
                                lineStyle:{
                                    color: '#666',
                                    opacity: '0.3',
                                    type:'dotted'
                                },
                                show:true
                            }
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            max: function (value) {
                                return value.max+2;
                            },
                            axisLabel: {
                                color:'#fff',
                                fontSize:16,
                                margin:15,
                            },
                            axisLine: {       // 坐标轴 轴线
                                show: true,  // 是否显示
                                // ------   线 ---------
                                lineStyle: {
                                    color: 'rgba(255, 255, 255, .5)',
                                    width: 1,
                                    type: 'solid',
                                    opacity: '0.3',
                                }
                            },
                            splitLine :{
                                lineStyle:{
                                    color: '#666',
                                    opacity: '0.3',
                                    type:'dotted',
                                    fontSize:16,
                                },
                                show:true
                            }
                        }
                    ],
                    series: {
                        type: 'bar',
                        itemStyle: {
                            normal: {
                                barBorderRadius: [3, 3, 0, 0],
                                color: (params)=>{
                                    let index_color = this.yoyoReportData[params.dataIndex].distanceDiff;
                                    if(index_color>0){
                                        return new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                            offset: 1,
                                            color: '#70FABB'
                                        },
                                            {
                                                offset: 0,
                                                color: '#E1E85B'
                                            }]);
                                    }else if(index_color==0){
                                        return new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                            offset: 1,
                                            color: '#EEBC31'
                                        },
                                            {
                                                offset: 0,
                                                color: '#FAE586'
                                            }])
                                    }else if(index_color<0){
                                        return new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                            offset: 1,
                                            color: '#EB4511'
                                        },
                                            {
                                                offset: 0,
                                                color: '#EC3C3C'
                                            }])
                                    }else{
                                        return new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                            offset: 0,
                                            color: '#2979FF'
                                        },
                                            {
                                                offset: 1,
                                                color: '#42A5F5'
                                            }]);
                                    }
                                }
                            }
                        },
                        data: data,
                        barWidth: 15,
                        label: {
                            show: true,
                            position: 'top',
                            align: 'center',
                            verticalAlign: 'middle',
                            distance: '10',
                            color: (params)=>{},
                            fontSize: '18',
                            formatter:  (params) => {
                                if (params.value >= 0) {
                                    return params.value;
                                } else {
                                    return '';
                                }
                            },
                        }
                    }
                };
                myChart.setOption(option, true);
                if(this.yoyoReportName.length){
                    let timeScroll=null
                    timeScroll=setTimeout(()=>{
                        const lookEl=document.querySelector('.teamReport')
                        const el = document.querySelector('#yoyoBar');
                        this.scrollDomWidth= el.offsetWidth - lookEl.offsetWidth + 100;
                        this.scrollTime= 3 +Math.floor(this.scrollDomWidth/500)*5;
                        if(this.scrollDomWidth>100){
                            clearInterval(this.time)
                            this.time = setInterval(this.scroll,(this.scrollTime*1000)+500)
                        }
                        clearInterval(timeScroll)
                    })
                }
            },
            //滚动
            scroll(){
                const el = document.querySelector('#yoyoBar');
                let style=el?el.getAttribute('style'): '';
                let styleStr='';
                if(style && style == 'margin-left:'+ -(this.scrollDomWidth)+'px;transition: all linear '+ this.scrollTime +'s'){
                    styleStr='margin-left:0px;transition: all linear '+ this.scrollTime +'s'
                }else {
                    styleStr='margin-left:'+ -(this.scrollDomWidth)+'px;transition: all linear '+ this.scrollTime +'s'
                }
                el?el.setAttribute('style',styleStr):'';
            }
        },
        beforeDestroy() {
            clearInterval(this.time);
        }
    }
</script>

<style scoped lang="less">
    .cardTit{
        background-image: url("../assets/img/updateImg/head_2.png");
        position: relative;
        font-size: 30px;
        .season{
            font-family: PingFangMedium;
            color: #fff;
            display: inline-block;
            position: absolute;
            line-height: 130px;
            left: 2vw;
        }
    }
    .cardBg{
        height: calc(100% - 115px);
        box-sizing: border-box;
        padding: 2vw;
        color: #fff;
        position: relative;
        .contTit{
            font-size: 30px;
        }
        .barTitCol{
            padding-bottom: 1vw;
            margin-right: 1vw;
            position: absolute;
            right: 3vw;
            top: 3.4vw;
            font-size: 26px;
            span {
                float: right;
            }
            .titCol {
                width: 20px;
                height: 20px;
            }
            .titColRed {
                background: #F34E4E;
            }
            .titColGreen {
                background: #76C072;
            }
            .titColYellow {
                background: #F3C74E;
            }
            .titColBlue {
                background: #7AAAF0;
            }
            .titLab {
                font-family: PingFang;
                color: #fff;
                padding-left: .5vw;
                padding-right: 1.5vw;
                margin-top: -8px;
            }
            .titGreen{
                color: #76C072;
            }
            .titYellow{
                color: #F3C74E;
            }
            .titRed{
                color: #F34E4E;
            }
            .titBlue{
                color: #7AAAF0;
            }
        }
        .teamReport{
            height: calc(100% - 2vw);
        }
        .barBox{
            margin-right: 1vw;
            margin-left: 1vw;
            width: calc( 100% - 2vw);
            height: 100%;
            overflow-x: auto;
            overflow-y: hidden;
        }
    }
</style>
